/** Monotonic ULID generator (Crockford base32, 48-bit time + 80-bit randomness). */
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

let lastTime = -1;
const lastRandom = new Uint8Array(10);

function fillRandom(buf: Uint8Array): void {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(buf);
  else for (let i = 0; i < buf.length; i++) buf[i] = Math.floor(Math.random() * 256);
}

function incrementRandom(buf: Uint8Array): void {
  for (let i = buf.length - 1; i >= 0; i--) {
    if (buf[i] === 255) {
      buf[i] = 0;
    } else {
      buf[i]++;
      return;
    }
  }
}

function encodeTime(time: number): string {
  let out = '';
  for (let i = 0; i < 10; i++) {
    const mod = time % 32;
    out = ENCODING[mod] + out;
    time = (time - mod) / 32;
  }
  return out;
}

function encodeRandom(buf: Uint8Array): string {
  // 80 bits → 16 base32 chars
  let out = '';
  let bits = 0;
  let value = 0;
  for (let i = 0; i < buf.length; i++) {
    value = (value << 8) | buf[i];
    bits += 8;
    while (bits >= 5) {
      out += ENCODING[(value >>> (bits - 5)) & 31];
      bits -= 5;
    }
    value &= (1 << bits) - 1;
  }
  return out;
}

export function ulid(now: number = Date.now()): string {
  if (now <= lastTime) {
    incrementRandom(lastRandom);
    now = lastTime;
  } else {
    lastTime = now;
    fillRandom(lastRandom);
  }
  return encodeTime(now) + encodeRandom(lastRandom);
}
